import { API_BASE_URL } from './api';

/**
 * Submit contact form (public, no auth).
 * @param {{ name: string, email: string, phone?: string, subject: string, message: string }} data
 */
export const submitContact = async (data) => {
  const response = await fetch(`${API_BASE_URL}/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      name: data.name?.trim() || '',
      email: data.email?.trim() || '',
      phone: data.phone?.trim() || undefined,
      subject: data.subject?.trim() || '',
      message: data.message?.trim() || '',
    }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(result.message || 'Failed to send message');
    err.response = { status: response.status, data: result };
    throw err;
  }
  return result;
};
